import "./App.css";
import React from "react";
import Routes from "./routes/routes.js";

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
